import { passkeysFaqItems } from './PasskeysFaqItems';
import PageTitleHook from '../../../utils/PageTitleHook/PageTitleHook';
import Accordion from '../../baseComponents/Accordion/Accordion';
import { Button, SectionalAlert } from '../../baseComponents';
import { useContext } from 'react';
import { pathContext } from '../../../contexts/contexts';
import './PasskeysFaq.css'


export const PasskeysFaq = () => {
  PageTitleHook('USCIS Online Account | Passkeys FAQ');
  const { setUrl } = useContext(pathContext);

  return (
    <div className="flex justify-center bg-white py-8 px-8">
      <div className="w-900" data-testid="passkeys-faq-container">
        <h1 className="text-3xl my-3 font-light text-dhs_font_gray">Passkeys Frequently Asked Questions</h1>

        <div>
          <h2 className="text-2xl font-medium text-dhs_font_gray">What are passkeys?</h2>
          <div className="pt-2 font-medium text-md text-dhs_font_gray">
            <p>
              Passkeys are a replacement for your password. With passkeys, you can sign into your USCIS online account using your face, fingerprint, or PIN. 
              Signing in with a passkey is simple, fast, and helps protect you against unauthorized attempts to access your information.
            </p>
            <br />
            <p>Passkeys are supported on desktop and mobile browsers.</p>
          </div>
          <br />
          <SectionalAlert type={'info-important'}>
            {'Your face and fingerprint biometric data stays on your device and is never shared with USCIS. '}
          </SectionalAlert>
        </div>

        <Accordion items={passkeysFaqItems} />
        <Button id="2fa-back-btn" text="Back" type="primary" onClick={() => setUrl('/sign-in')} />
      </div>
    </div>
  );
};
